import type { ContactDetailsResponse } from '#pie/internal/api/pie-bff';
import { createSortingAtom } from './createSortingAtom';
import type { DefaultSorting } from './defaultSorting';

export const defaultContactDetailsSorting: DefaultSorting<ContactDetailsResponse> =
  {
    desc: false,
    id: 'fullName',
  };

export const contactDetailsSortingAtom = createSortingAtom({
  defaultSorting: defaultContactDetailsSorting,
});
